import { TrialInfoView } from '../features/onboarding/subscriptionsComponents.tsx'
export function TrialInfoPage() {
  return <TrialInfoView />
}
